import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { routeTree } from 'src/routeTree.gen';
import { RouteLoadingFallback } from 'src/shared/components/RouteLoadingFallback';

function stringifySearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value));
    }
  }
  const str = params.toString();
  return str ? `?${str}` : '';
}

function parseSearch(searchStr: string): Record<string, string> {
  const str = searchStr.startsWith('?') ? searchStr.slice(1) : searchStr;
  const params = new URLSearchParams(str);
  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}

export function createRouter() {
  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: RouteLoadingFallback,
    defaultPendingMs: 200,
    defaultPendingMinMs: 200,
    stringifySearch,
    parseSearch,
  });

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
